import { createApp, toRaw } from "vue"
import { Swiper, SwiperSlide } from "swiper/vue"
import { Scrollbar, Pagination } from "swiper"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/scrollbar"
import BudgetModal from "../components/BudgetModal.vue"

createApp({
    components: {
        Swiper,
        SwiperSlide,
        gallery: null,
    },
    methods: {
        setSwiper(swiper) {
            this.gallery = swiper
        },
        swiperNext() {
            this.gallery?.slideNext()
        },
        swiperPrev() {
            this.gallery?.slidePrev()
        },
    },
}).mount("#carousel")

createApp({
    components: {
        BudgetModal,
    },
    data() {
        return {
            budget: false,
        }
    },
}).mount("#budget")
